import axios from 'axios';
import { Collection } from '../models/Collection';
import { QEForm } from '../models/QEForm';

export const fetchFormsList = async () => {
  const response = await axios.get<Collection<QEForm>>('/forms/list');
  return response.data.items;
};
